[
  {
    "id": "suelto",
    "name": "Suelto",
    "thumb": "/hairstyles/suelto.jpg",
    "prompt": "Hairstyle: worn loose and down, falling naturally over the shoulders and back with a few dreadlocks in front."
  },
  {
    "id": "mono",
    "name": "Rodete alto",
    "thumb": "/hairstyles/mono.jpg",
    "prompt": "Hairstyle: gathered into a medium, neat high bun on top of the head — noticeably smaller and less voluminous than an oversized bun, about 15% smaller — with a few dreadlocks left hanging at the sides and the nape."
  },
  {
    "id": "semirrecogido",
    "name": "Semi recogido",
    "thumb": "/hairstyles/semirrecogido.jpg",
    "prompt": "Hairstyle: half-up, the top half tied back into a knot at the crown and the rest falling loose over the shoulders."
  },
  {
    "id": "coleta",
    "name": "Coleta alta",
    "thumb": "/hairstyles/coleta.jpg",
    "prompt": "Hairstyle: all the dreadlocks pulled into a high ponytail tied with a hair band, hanging down the back and over one shoulder.",
    "hidden": true
  },
  {
    "id": "trenzas",
    "name": "Dos trenzas",
    "thumb": "/hairstyles/trenzas.jpg",
    "prompt": "Hairstyle: parted in the middle and worn as two thick braids of dreadlocks, one over each shoulder, with small metal rings woven in.",
    "hidden": true
  }
]
